import React from 'react';
import { motion } from 'framer-motion';

interface PageLayoutProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  className?: string;
}

export const PageLayout: React.FC<PageLayoutProps> = ({ 
  title, 
  subtitle, 
  children, 
  className = '' 
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className={`min-h-screen bg-slate-50 dark:bg-slate-900 ${className}`}
    >
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <header className="mb-8 text-center">
          <h1 className="text-4xl font-bold text-slate-900 dark:text-white mb-4">
            {title}
          </h1>
          {subtitle && (
            <p className="text-xl text-slate-600 dark:text-slate-300">
              {subtitle}
            </p>
          )}
        </header>
        <main className="prose prose-slate dark:prose-invert max-w-none">
          {children}
        </main>
      </div>
    </motion.div>
  );
};